module.exports = __webpack_public_path__ + "static/media/checkbox.fefaa511.svg";